export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

export const API_ENDPOINTS = {
  AUTH: `${API_BASE_URL}/jwt/auth`,
  DATA: `${API_BASE_URL}/data`,
  ADMIN: `${API_BASE_URL}/admin`,
};
